/**
 * 烘干厂模块开关配置 API (仅 SUPPER_ADMIN 用).
 * 后端: hl-drying/.../DryingFactoryModuleController
 *   GET  /hl-drying/drying/factoryModule/config?factoryId=   (2026-10-23 起响应附带 feVersion)
 *   POST /hl-drying/drying/factoryModule/save
 *   POST /hl-drying/drying/factoryModule/feVer/save          (2026-10-23 前端版本灰度 V2/V3)
 *   GET  /hl-drying/drying/factoryModule/disabled?factoryId=
 *
 * 另外复用烘干厂管理接口列出所有厂:
 *   GET  /hl-drying/drying/factoryManage/list
 */
import request from '@/utils/request'

/** 列出所有烘干厂 (外部组织), 用于「烘干厂分配」页面左侧列表 */
export function listAllFactories() {
  return request.get('/hl-drying/drying/factoryManage/list')
}

/** 查指定厂的模块开关配置 (返回 4 个模块完整列表 + feVersion, 缺失默认 Y / V2) */
export function getModuleConfig(factoryId) {
  return request.get('/hl-drying/drying/factoryModule/config', { params: { factoryId } })
}

/** 保存模块开关配置
 * data: { factoryId, modules: [{moduleCode, enabled}] }
 */
export function saveModuleConfig(data) {
  return request.post('/hl-drying/drying/factoryModule/save', data)
}

/** 保存烘干厂前端版本灰度开关 (双前端按厂指定)
 * data: { factoryId, feVersion: 'V2' | 'V3' }  — 生效时机: 该厂用户下次登录
 */
export function saveFactoryFeVersion(data) {
  return request.post('/hl-drying/drying/factoryModule/feVer/save', data)
}

/** 查指定厂禁用的模块 code 列表 */
export function getDisabledModules(factoryId) {
  return request.get('/hl-drying/drying/factoryModule/disabled', { params: { factoryId } })
}

